'use client';

import { Modal } from '@bytel/trilogy-react';

import { UpsellModalComponentType } from '@app-types/eligibility/config';

import { ByouUpsellModal } from './byou-upsell-modal';
import { CmsUpsellModal } from './cms-upsell-modal';
import { DowngradePlayUpsellModal } from './downgrade-play-upsell-modal';
import { FaiUpsellModalProps } from './fai-upsell-modal.props';

export interface UpsellModalContainerProps extends FaiUpsellModalProps {
    type: UpsellModalComponentType;
    onClose: () => void;
}

export function FaiUpsellModalContainer({ type, onClose, ...props }: Readonly<UpsellModalContainerProps>) {
    let content;
    let title;

    switch (type) {
        case UpsellModalComponentType.BYOU:
            title = `Besoin de la box TV\u00A0?`;
            content = <ByouUpsellModal {...props} />;
            break;
        case UpsellModalComponentType.DOWNGRADE_MUST_PLAY:
            title = `Choisissez votre expérience TV`;
        case UpsellModalComponentType.DOWNGRADE_ULTYM_PLAY:
            title = `Choisissez votre expérience TV`;
            content = <DowngradePlayUpsellModal {...props} />;
            break;
        case UpsellModalComponentType.CLASSIC:
        default:
            title = `Envie d'une ${props.upsellOffer.name}\u00A0?`;
            content = <CmsUpsellModal {...props} />;
            break;
    }

    return (
        <Modal active onClose={onClose} title={title}>
            {content}
        </Modal>
    );
}
